// extracted by mini-css-extract-plugin
export default {"pricing":"PricingPage_pricing__to6VF","container":"PricingPage_container__XAnNh","pricing__price":"PricingPage_pricing__price__CPY43"};